if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        this.expressCheckoutBtn = this.querySelector('.js-custom-express-checkout');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        if (this.expressCheckoutBtn) {
          this.expressCheckoutBtn.addEventListener('click', this.handleExpressCheckoutSubmit.bind(this));
        }

        this.addExpressCheckoutBtnHandler();
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: this.getItemsDataToAdd()
        });

        const data = await response.json();

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);
        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 200);
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();
          setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 200);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }

        const expressButtonElems = document.querySelectorAll('.js-express-checkout');
        expressButtonElems.forEach((btn) => {
          btn.remove();
        });

        this.resetProductForm();
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');

        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    resetProductForm() {
      const quantityInput = document.querySelector('input[name="quantity"]');
      const productInfoEl = this.closest('.js-product-info');
      const giftWrapInput = document.querySelector('input[name="gift_wrap"]');
      const engravingInput = productInfoEl.querySelector('textarea[name="properties[Engraving Text]"]');

      const canvas = document.querySelector('#engraving-canvas');
      const ctx = canvas.getContext('2d');

      if (quantityInput) quantityInput.value = 1;

      if (giftWrapInput) giftWrapInput.checked = false;
      if (engravingInput) engravingInput.value = '';

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      document.body.classList.remove('engraving');
      canvas.classList.remove('stick');
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }

    async handleExpressCheckoutSubmit(evt) {
      if (evt.target.id === 'product-signup_form' || this.expressCheckoutBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.expressCheckoutBtn.setAttribute('aria-disabled', 'true');
      this.expressCheckoutBtn.classList.add('is-loading');

      try {
        await fetch(`${theme.routes.cartClear}.js`);

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: this.getItemsDataToAdd()
        });

        this.resetProductForm();
        
        setTimeout(() => {
          window.location.href = "/checkout";
        }, 200);
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        this.expressCheckoutBtn.classList.add('is-success');
        this.expressCheckoutBtn.removeAttribute('aria-disabled');

        setTimeout(() => {
          this.expressCheckoutBtn.classList.remove('is-loading');
          this.expressCheckoutBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    addExpressCheckoutBtnHandler() {
      const productInfoEl = this.closest('.js-product-info');
      if (!productInfoEl) return;

      const giftWrapCheckbox = productInfoEl.querySelector('input[name="gift_wrap"]');
      const engravingInput = productInfoEl.querySelector('textarea[name="properties[_Engraving Text]"]');
      const expressCheckoutBtn = productInfoEl.querySelector('.product-info__dynamic-checkout-button');
      const expressCheckoutMessageEl = productInfoEl.querySelector('.js-express-checkout-unavailable-message');

      if (expressCheckoutMessageEl) {
        expressCheckoutMessageEl.style.height = `${expressCheckoutBtn.clientHeight}px`;

        const toggleExpressCheckout = () => {
          const engravingEntered = engravingInput && engravingInput.value.trim().length > 0;
          const giftWrapSelected = giftWrapCheckbox && giftWrapCheckbox.checked;

          if (engravingEntered || giftWrapSelected) {
            if (expressCheckoutBtn) expressCheckoutBtn.style.display = 'none';
            expressCheckoutMessageEl.style.display = '';
          } else {
            if (expressCheckoutBtn) expressCheckoutBtn.style.display = '';
            expressCheckoutMessageEl.style.display = 'none';
          }
        };
        
        if (giftWrapCheckbox) {
          giftWrapCheckbox.addEventListener('change', toggleExpressCheckout);
        }
    
        if (engravingInput) {
          engravingInput.addEventListener('input', toggleExpressCheckout);
        }
    
        toggleExpressCheckout();
      }
    }

    createHash() {
      return (() => {
        const chars = "0123456789abcdef";
        let hash = "";
        for (let i = 0; i < 32; i++) {
          hash += chars[Math.floor(Math.random() * chars.length)];
        }
        return hash;
      })();
    }

    getMappedEngravingText(engravingText) {
      /* DEVELOPER NOTE */
      /*
        THE ABOVE MAPPING does NOT contain the actual unicode escape sequences of the symbols in the comments on each line
        The unicode escape sequences presented above are not actually printable on most fonts
        The only reason they print on the site is because for some reason, those escape sequences map to symbols on the "Classic" font

        They don't render anywhere if the "Classic" font isn't used (not even on the final checkout page)
      */

      let _engravingText = engravingText;
      const mapping = {
        "§": "\ue90a", // 🖤
        "¥": "\ue906", // ★
        "£": "\ue909", // ✿
        "[": "\ue90e", // ☮
        "]": "\ue90b", // ☯
        "{": "\ue90d", // ♫
        "}": "\ue90c", // ♪
        "²": "\ue910", // ®
        "³": "\ue911", // ☺
        "|": "\ue908", // ⚓
        ">": "\ue912", // ☼
        ";": "\ue90f" // ♠
      };

      Object.entries(mapping).forEach(([key,value]) => {
        _engravingText = _engravingText.replaceAll(new RegExp(value, "g"), key);
      });

      return _engravingText;
    }

    getItemsDataToAdd() {
      const currentFormData = new FormData(this.form);
      const combinedFormData = new FormData();

      const sections = `cart-icon-bubble${this.cartDrawer ? `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}` : ''}`;

      const engravingVariantId = currentFormData.get("properties[_id_of_variant_with_engraving]") || "";
      const engravingImage = currentFormData.get("properties[_Engraving]");
      const engravingText = currentFormData.get("properties[_Engraving Text]")?.trim();
      const isEngraving = engravingText && engravingText.length > 0 && engravingVariantId && engravingVariantId.length > 0 && (!isNaN(engravingVariantId) && engravingImage !== undefined);

      const giftWrapInput = document.querySelector('input[name="gift_wrap"]');
      const isGiftWrap = giftWrapInput && giftWrapInput.checked;

      combinedFormData.append(`items[0][id]`, currentFormData.get('id'));
      combinedFormData.append(`items[0][quantity]`, currentFormData.get('quantity') || 1);

      combinedFormData.append('sections_url', window.location.pathname);
      combinedFormData.append('sections', sections);

      if (!isEngraving && !isGiftWrap) return combinedFormData;

      const hash = this.createHash();

      if (isEngraving || isGiftWrap) {
        combinedFormData.append('items[0][properties][_hash]', hash);
      }

      if (isEngraving) {
        const _engravingText = this.getMappedEngravingText(engravingText);

        combinedFormData.append('items[1][id]', engravingVariantId);
        combinedFormData.append('items[1][quantity]', currentFormData.get('quantity') || 1);
        combinedFormData.append('items[1][properties][_Engraving]', engravingImage);
        combinedFormData.append('items[1][properties][_id_of_variant_with_engraving]', engravingVariantId);
        combinedFormData.append('items[1][properties][_Engraving Text]', engravingText);
        combinedFormData.append('items[1][properties][_Engraving Font]', currentFormData.get('properties[_Engraving Font]') || '');
        combinedFormData.append('items[1][properties][_hash]', hash);

        combinedFormData.append('items[0][properties][_mapped_engraving_text]', _engravingText);
        combinedFormData.append('items[0][properties][_id_of_variant_with_engraving]', engravingVariantId);
        combinedFormData.append('items[0][properties][_Engraving Font]', currentFormData.get('properties[_Engraving Font]') || '');
      }

      if (isGiftWrap) {
        const variantId = giftWrapInput.value; 
        const sku = giftWrapInput.getAttribute('data-sku');

        combinedFormData.append(`items[${isEngraving ? 2 : 1}][id]`, variantId);
        combinedFormData.append(`items[${isEngraving ? 2 : 1}][quantity]`, 1);
        combinedFormData.append(`items[${isEngraving ? 2 : 1}][properties][_main_product_sku]`, sku);
        combinedFormData.append(`items[${isEngraving ? 2 : 1}][properties][_hash]`, hash);
      }

      return combinedFormData;
    }
  }

  customElements.define('product-form', ProductForm);
}
